import { createContext } from 'react';

interface IContractContext {
  services: any;
  auth: any;
  setCurrentStep: (id: string) => void;
  userBankAccount: object;
  propertyAnnouncement: object;
  proposition: object;
}

const contractContext = createContext<IContractContext | any>(null);

export default contractContext;